import { useCallback, useRef, useState } from 'react'
import { AutocompleteActionsPaper } from './AutocompleteActionsPaper'
import type { AutocompleteAction } from './AutocompleteActionsPaper'
import type { PaperProps } from '@mui/material'

/** Wires an autocomplete's open state to a paper that pins actions below its options. The actions are
 * read through a ref so the paper keeps its identity: a fresh one remounts the popup while it is open,
 * which an autocomplete rendered by a row that re-renders as it is typed into would do constantly. */
export const useAutocompleteActionsPaper = (actions: AutocompleteAction[], initiallyOpen = false) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  const actionsRef = useRef(actions)
  actionsRef.current = actions

  const paper = useCallback(
    (paperProps: PaperProps) => (
      <AutocompleteActionsPaper bounded actions={actionsRef.current} setIsOpen={setIsOpen} {...paperProps} />
    ),
    []
  )

  return { isOpen, setIsOpen, paper }
}
